class IncartUpsell extends HTMLElement {
  constructor() {
    super();

    this.slider = null;
    this.slides = [];
    this.currentTranslate = 0;
    this.prevTranslate = 0;
    this.startPos = 0;
    this.isDragging = false;
    this.currentIndex = 0;
  }

  connectedCallback() {
    this.initializeSlider();
    this.addDatalayerEvent();
  }

  initializeSlider() {
    this.slider = this.querySelector('.splide__list');

    if (!this.slider) return;

    this.slides = [...this.slider.querySelectorAll('.splide__slide')];

    if (this.slides.length <= 1) return;

    this.setupSlider();
    this.initDrag();
  }

  setupSlider() {

    const perPage = window.innerWidth < 749
      ? parseInt(this.dataset.mobilePerPage || 1)
      : parseInt(this.dataset.desktopPerPage || 1);

    const gap = window.innerWidth < 749
      ? this.dataset.gapBetweenSlidesOnMobile || '12px'
      : this.dataset.gapBetweenSlides || '20px';

    const paddingRight = window.innerWidth < 749
      ? this.dataset.mobilePaddingRight || '20%'
      : this.dataset.desktopPaddingRight || '20%';

    this.style.overflow = 'hidden';

    const track = this.querySelector('.splide__track');

    if (track) {
      track.style.overflow = 'hidden';
      track.style.paddingRight = paddingRight;
    }

    this.slider.style.display = 'flex';
    this.slider.style.gap = gap;
    this.slider.style.transition = 'transform 0.3s ease';
    this.slider.style.willChange = 'transform';
    this.slider.style.touchAction = 'pan-y';
    this.slider.style.padding = '0';
    this.slider.style.margin = '0';
    this.slider.style.listStyle = 'none';

    this.slides.forEach((slide) => {
      slide.style.minWidth = `calc((100% / ${perPage}) - ${gap})`;
      slide.style.flexShrink = '0';
    });
  }

  initDrag() {

    this.slider.addEventListener(
      'touchstart',
      this.touchStart.bind(this),
      { passive: true }
    );

    this.slider.addEventListener(
      'touchmove',
      this.touchMove.bind(this),
      { passive: true }
    );

    this.slider.addEventListener(
      'touchend',
      this.touchEnd.bind(this)
    );

    this.slider.addEventListener(
      'mousedown',
      this.touchStart.bind(this)
    );

    this.slider.addEventListener(
      'mousemove',
      this.touchMove.bind(this)
    );

    this.slider.addEventListener(
      'mouseup',
      this.touchEnd.bind(this)
    );

    this.slider.addEventListener(
      'mouseleave',
      this.touchEnd.bind(this)
    );
  }

  touchStart(event) {
    this.isDragging = true;

    this.startPos = this.getPositionX(event);

    this.slider.style.transition = 'none';
  }

  touchMove(event) {
    if (!this.isDragging) return;

    const currentPosition = this.getPositionX(event);

    const diff = currentPosition - this.startPos;

    this.currentTranslate = this.prevTranslate + diff;

    this.setSliderPosition();
  }

  touchEnd() {

    if (!this.isDragging) return;

    this.isDragging = false;

    const movedBy = this.currentTranslate - this.prevTranslate;

    const slideWidth =
      this.slides[0].offsetWidth + 20;

    if (
      movedBy < -50 &&
      this.currentIndex < this.slides.length - 1
    ) {
      this.currentIndex += 1;
    }

    if (
      movedBy > 50 &&
      this.currentIndex > 0
    ) {
      this.currentIndex -= 1;
    }

    this.currentTranslate =
      -this.currentIndex * slideWidth;

    this.prevTranslate =
      this.currentTranslate;

    this.slider.style.transition =
      'transform 0.3s ease';

    this.setSliderPosition();
  }

  getPositionX(event) {
    return event.type.includes('mouse')
      ? event.pageX
      : event.touches[0].clientX;
  }

  setSliderPosition() {
    this.slider.style.transform =
      `translateX(${this.currentTranslate}px)`;
  }

  addDatalayerEvent() {

    this.querySelectorAll(".quick-add__submit")
      .forEach((eachProduct) => {

      eachProduct.addEventListener('click', () => {

        const cartItems =
          document.querySelectorAll(
            "#CartDrawer-CartItems tr"
          );

        if (!cartItems.length) return;

        const lastAddedProduct =
          cartItems[0]
            ?.querySelector(".cart-item__details a")
            ?.textContent || '';

        const cartDrawer =
          document.querySelector(
            "cart-drawer .drawer__inner"
          );

        const spinnerContainer =
          cartDrawer?.querySelector(
            ".cart-drawer__spinner-wrapper"
          );

        spinnerContainer?.classList.remove(
          'hide-loader'
        );

        const clevertapData = {
          Previous_Product_Added_To_Cart:
            lastAddedProduct,

          Previous_Page:
            document.referrer,

          Landing_Page:
            eachProduct.dataset.productLink,

          Custom_Upsell_PDP_Name:
            eachProduct.dataset.productName,

          Custom_Upsell_PDP_Price:
            eachProduct.dataset.productPrice,

          Custom_Upsell_PDP_Qty: 1
        };

        window.dataLayer =
          window.dataLayer || [];

        dataLayer.push({
          event: "Custom_Upsell",
          ...clevertapData,
          clevertap: clevertapData
        });

      });

    });
  }
}

customElements.define(
  'incart-upsell',
  IncartUpsell
);